import { IDeviceStrategy } from '../strategies/IDeviceStrategy';
import { LowMemoryDeviceStrategy } from '../strategies/LowMemoryDeviceStrategy';
import { HighPerformanceDeviceStrategy } from '../strategies/HighPerformanceDeviceStrategy';
import { IOSSafariStrategy } from '../strategies/IOSSafariStrategy';

export class DeviceStrategyFactory {
  static createStrategy(): IDeviceStrategy {
    const nav = navigator as any;
    const ua = navigator.userAgent;

    // All iOS browsers use WebKit, which has memory constraints
    const isIOS = /iPad|iPhone|iPod/.test(ua);

    if (isIOS) {
      return new IOSSafariStrategy();
    }

    const memory = nav.deviceMemory || nav.hardwareConcurrency || 4;
    const isLowMemory = memory <= 4;

    if (isLowMemory) {
      return new LowMemoryDeviceStrategy();
    } else {
      return new HighPerformanceDeviceStrategy();
    }
  }
}